import createPermission from 'permissions/createPermission'

export default createPermission('system.roles.list')